import BaseService from '@/ecm/common/BaseService.js'

class AlertService {
  baseUrl = 'alert';

  getDocumentList = (documentId) => BaseService.get({ url: `${this.baseUrl}/get-document-list/${documentId}` });
  getUserList = () => BaseService.get({ url: `${this.baseUrl}/get-user-list` });
  getCount = () => BaseService.get({ url: `${this.baseUrl}/get-count` });
  remove = (id) => BaseService.post({ url: `${this.baseUrl}/remove/${id}` });
  removeUserAlert = (dto) => BaseService.post({ url: `${this.baseUrl}/remove-user-alert`, data: dto });
  save = (alert) => BaseService.post({ url: `${this.baseUrl}/save`, data: alert });
}

export default new AlertService()
